import { useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';
import { getCustomerDefaultSettingsEffect } from '../settings/SettingsEffects';

interface CustomerDefaultSettings {
  customerKey: number; // example, 5060
  type: string; // example, Shipment
  parameterName: string; // example, DefaultCountryCode, UnitofMeasureQty, UnitofMeasureBillQty
  defaultValue: string; // example, US
}

export type CustomerDefaultSettingsResponse = CustomerDefaultSettings[];

export const fetchCustomerDefaultSettings = async (
  customerKey: number,
  type?: string,
  parameterName?: string,
): Promise<CustomerDefaultSettingsResponse> => {
  const response: AxiosResponse<CustomerDefaultSettingsResponse> = await getCustomerDefaultSettingsEffect({
    customerKey,
    type,
    parameterName,
  });
  return response.data;
};

export const useGetDefaultCustomerSettings = (customerKey: number, type?: string, parameterName?: string) => {
  return useQuery<CustomerDefaultSettingsResponse, Error>({
    queryKey: ['customerDefaultSettings', customerKey, type, parameterName],
    queryFn: () => fetchCustomerDefaultSettings(customerKey, type, parameterName),
    enabled: !!customerKey,
  });
};
